import * as React from 'react';
import { OperationContext } from '../../config';
import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import type { IFormContext } from 'Containers/FormContextHandler';
import { withFormContext } from 'Containers/FormContextHandler';
import { isNumber } from 'neuro-utils';

const IntracranialImaging = ({
  formData,
  editing,
  view,
  fm,
}: IFormContext<IDocumentWithTypeV2<'epilepsySurgicalTreatment'>>): React.JSX.Element => {
  const editingDoc = !!editing && !view?.viewing;
  const { document, onChange } = formData;

  return (
    <React.Fragment>
      <OperationContext.Consumer>
        {({ operationIndex }): React.JSX.Element => {
          const { operations } = document;

          if (
            !(operations ?? []).length ||
            !isNumber(operationIndex) ||
            operations?.[operationIndex]?.typeOfOperation !== 'intracranialImaging'
          ) {
            return <></>;
          }

          const imaging = operations[operationIndex];

          const imagingOnChange = (values: TOnChangeValues): void => {
            const changedOperation = { ...imaging, ...values };
            operations[operationIndex] = changedOperation;
            onChange?.({ operations });
          };

          return (
            <>
              <FormRow title="surgicalTreatment.operation.typeOfOperation.opts.intracranialImaging">
                <InputHandler
                  type="Radio"
                  name="imagingType"
                  editing={editingDoc}
                  formData={{ document: { imagingType: imaging.imagingType }, onChange: imagingOnChange }}
                  options={['stereoEEG', 'grid', 'strip']}
                  optionFormatter={(opt: string | number): string =>
                    fm('surgicalTreatment.intracranialImaging.opts.' + opt)
                  }
                />
              </FormRow>
              <FormRow title="surgicalTreatment.stereoEEG.electrodeNumber.title">
                <InputHandler
                  type="NumberField"
                  name="electrodeNumber"
                  editing={editingDoc}
                  formData={{ document: { electrodeNumber: imaging.electrodeNumber }, onChange: imagingOnChange }}
                  placeholder={'surgicalTreatment.stereoEEG.electrodeNumber.placeholder'}
                  precision={0}
                  max={100}
                />
              </FormRow>
              <FormRow title="surgicalTreatment.stereoEEG.electrodeLocation.title">
                <InputHandler
                  type="Radio"
                  name="electrodeLocation"
                  editing={editingDoc}
                  formData={{ document: { electrodeLocation: imaging.electrodeLocation }, onChange: imagingOnChange }}
                  options={['left', 'right', 'both']}
                  optionFormatter={opt => fm('surgicalTreatment.stereoEEG.electrodeLocation.opts.' + opt)}
                />
              </FormRow>
            </>
          );
        }}
      </OperationContext.Consumer>
    </React.Fragment>
  );
};

export default withFormContext(IntracranialImaging);
